import React, { MouseEvent, ReactElement } from 'react';
import { EditorState } from 'draft-js';
import { SerializedStyles, css } from '@emotion/react';
import addCTA from '../modifiers/addCTA';
import { ENTITY_TYPE } from '../../utils/types';
import { EditorTheme } from '../../../EditorTheme';
import { CTAButtonIcon } from '$/images/Icons';
import EditorUtils from '../../draft-js-plugins-utils/src';

export interface CTAButtonTheme {
  buttonWrapper?: SerializedStyles;
  button?: SerializedStyles;
  active?: SerializedStyles;
}

export interface CTAButtonProps {
  defaultText?: string;
  theme?: CTAButtonTheme;
  getEditorState?: () => EditorState;
  setEditorState?: (state: EditorState) => void;
}

const CTAButton = (props: CTAButtonProps): ReactElement => {
  const onClick = (event: MouseEvent): void => {
    event.preventDefault();

    const editorState = props?.getEditorState?.();
    if (!editorState) return;
    const newEditorState = addCTA(editorState, {
      text: props.defaultText ?? 'Register now',
    });

    props?.setEditorState?.(newEditorState);
  };

  const preventBubblingUp = (event: MouseEvent): void => {
    event.preventDefault();
  };

  const blockTypeIsActive = (): boolean => {
    const editorState = props?.getEditorState?.();
    if (!editorState) return false;
    const type = editorState
      .getCurrentContent()
      .getBlockForKey(editorState.getSelection().getStartKey())
      .getType();
    return type === ENTITY_TYPE.BUTTON || EditorUtils.hasEntity(editorState, 'BUTTON');
  };

  const theme = EditorTheme.buttonStyles;
  const styles = blockTypeIsActive() ? [theme.button, theme.active] : theme.button;

  return (
    <div className='ctaButton' css={theme.buttonWrapper} onMouseDown={preventBubblingUp}>
      <button
        className={blockTypeIsActive() ? 'active' : ''}
        css={styles}
        onClick={onClick}
        type='button'
      >
        <CTAButtonIcon
          css={css`
            height: 2rem !important;
            fill: none !important;
          `}
        />
      </button>
    </div>
  );
};

export default CTAButton;
